import { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { NeedHelpCard } from './NeedHelpCard';

// Reuses the sidebar's real Platform Support panel (same live Documentation
// link and Report-an-Issue mailto) rather than inventing a separate "Help
// & Support" destination that doesn't exist anywhere in this app.
export const HeaderHelpButton = () => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton
        size="small"
        aria-label="Help"
        onClick={e => setAnchor(e.currentTarget)}
      >
        <HelpOutlineIcon fontSize="small" />
      </IconButton>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ style: { width: 260, boxShadow: 'none' } }}
        elevation={2}
      >
        <NeedHelpCard />
      </Popover>
    </>
  );
};
